import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from 'components/ProtectedRoute';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// render - sample page
const Usuarios = Loadable(lazy(() => import('pages/auth/usuarios')));
const Distritos = Loadable(lazy(() => import('pages/auth/distritos')));
const Socios = Loadable(lazy(() => import('pages/auth/socios')));
const Envios = Loadable(lazy(() => import('pages/auth/envios')));
const Enviosa = Loadable(lazy(() => import('pages/auth/enviosa')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'usuarios',
      element: <Usuarios />
    },
    {
      path: 'distritos',
      element: <Distritos />
    },
    {
      path: 'socios',
      element: <Socios />
    },
    {
      path: 'envios',
      element: <Envios />
    }    ,
    {
      path: 'enviosa',
      element: <Enviosa />
    }
  ]
};

export default MainRoutes;
